import React from "react";
import {
  Svg,
  Line,
  Polyline,
  Polygon,
  Path,
  Rect,
  Circle,
  Ellipse,
  Text,
  Tspan,
  G,
  Stop,
  ClipPath,
  LinearGradient,
  RadialGradient,
} from "@react-pdf/renderer";

export const Feuille = ({color} : {color: string}) => {
  // @ts-ignore
  return (<Svg id="Calque_1" data-name="Calque 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 63.07 102.48">
  <G fill={color}>
    <Path d="M54.74,1.11c-.79-.97-2.09-1.35-3.27-.95-10.32,3.44-29.82,14.4-41.26,30.52-10.82,15.24-18.5,34.16,6.35,58.94.17,6.6,1.18,10.33,1.29,10.7.46,1.59,2.11,2.51,3.7,2.06.16-.05.31-.1.46-.17,1.3-.61,2.01-2.09,1.61-3.53-.02-.08-.83-3.13-1-8.71l10.32-2.74c.3-.09,3.03-.9,6.73-2.63,6.73-3.16,16.68-9.38,21.02-19.86,4.96-11.98,1.17-20.55-2.17-28.11-1.29-2.92-2.52-5.69-3.27-8.63-2.74-10.65-4.25-16.52-.22-23.47.62-1.08.52-2.43-.27-3.4ZM33.84,42.31c-5.46,11.85-9,23.39-10.5,34.31-.24,1.72-.42,3.43-.55,5.09-.09,1.11-.77,2.04-1.72,2.48-.46.21-.97.31-1.51.27-1.65-.13-2.88-1.57-2.75-3.23.14-1.77.34-3.6.59-5.43,1.58-11.51,5.28-23.62,10.99-36.01.69-1.5,2.48-2.16,3.98-1.47,1.5.69,2.16,2.48,1.47,3.98Z"/>
  </G>
</Svg>
);
};

export default Feuille;
